<template>
  <generic-container
    :title="$t('tibix')"
    icon="mobile alternate"
    :configurable="true"
    v-bind:configure_modal="configure_modal"
    :header_buttons="header_buttons"
  >
    <div class="ui icon warning message">
      <i class="inbox icon"></i>
      <div class="content">
        <div class="header">
          Pending
        </div>
        <p>Nothing to show here for now</p>
      </div>
    </div>
  </generic-container>
</template>

<script>
// import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import { enterprise_setup } from "@/utils";
// import filters from "@/filters";

export default {
  name: "TibixIndex",
  components: { "generic-container": GenericContainer },
  data() {
    return {
      configure_modal: ConfigureModal,
      header_buttons: [
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.refresh,
        },
      ],
      datatable: {},
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    refresh() {
      this.init();
    },
    init() {},
  },
  mounted() {
    let vm = this;
    vm.init();
  },
};
</script>
